import { useQuery } from '@tanstack/react-query'

import type { RevealUserConfig } from '@albacross/types'

import { get } from 'utils/http'

export type RevealCustomer = RevealUserConfig & { name: string | null }

export const useRevealCustomers = () =>
  useQuery({
    queryKey: ['revealApi'],
    queryFn: () => get<RevealCustomer[]>('/management/reveal_api/customers'),
  })
